import { IconCheckSuccess, IconError } from '@/assets/icons';
import { Button } from '@/components';
import OrderResponse from '@/model/OrderResponse';
import PaymentStatus from '@/model/PaymentStatus';
import React, { JSX } from 'react';

interface StateProps {
  orderResponse: OrderResponse;
}

interface DispatchProps {
  onTryAgain: () => void;
}

type Props = StateProps & DispatchProps;

export const FinishedContent: React.FC<Props> = ({ orderResponse, onTryAgain }): JSX.Element => (
  <div className="mx-auto">
    {orderResponse.paymentStatus === PaymentStatus.APPROVED && !orderResponse.paymentMessage && (
      <div className="flex flex-col justify-center justify-between items-center">
        <IconCheckSuccess height="80px" className="text-[#7AD81B] mb-[30px]" />
        <h4 className="font-dmsans font-bold text-neutro-b-400 text-[21px] mb-[20px] text-center">
          A sua compra foi realizada com sucesso!
        </h4>
      </div>
    )}
    {orderResponse.paymentMessage && (
      <div className="flex flex-col justify-center">
        <IconError height="89px" className="self-center text-[#E64F49] mb-[30px]" />
        <h4 className="font-dmsans font-bold text-neutro-b-400 text-[21px] mb-[20px] text-center">
          Ops! Pagamento não realizado
        </h4>
        <p className="font-dmsans text-base font-normal text-neutro-w-600 mb-[70px]">
          Ocorreu um erro durante o processamento do seu pedido. Por favor, tente novamente
          finalizar o seu pedido.
        </p>
        {orderResponse.paymentMessage && (
          <p className="font-dmsans text-base font-normal text-neutro-w-600 mb-[70px]">
            {orderResponse.paymentMessage}
          </p>
        )}
        <div className="grid grid-cols-1 gap-5">
          <Button
            type="button"
            title="Tentar novamente"
            buttonStyle="primary"
            size="lg"
            className="w-full mb-[25px]"
            onClick={() => onTryAgain()}
          />
        </div>
      </div>
    )}
  </div>
);
